import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { Stack, Typography } from "@mui/material";
import { usePutAuthRoleMutation } from "Auth/Api/Mutations/usePutAuthRoleMutation";
import { MooneLiteEULACheckboxLabel } from "Components/Auth/SignUp/MooneLiteEULACheckboxLabel";
import { AccessRoleCodes } from "Models/AccessRoleCodes";
import { RoleSelectionCard } from "Components/Onboarding/SSO/RoleSelectionCard";
import { PrimaryButton } from "Components/Shared/Buttons/PrimaryButton";
import { CheckboxInput } from "Components/Shared/Inputs/CheckboxInput";
import { getUserInfoAsync } from "State/Auth/UserInfo/GetUserInfoState";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { Resources, useResource } from "Translations/Resources";

/**
 * Legacy RoleSelection fallback (BankID-era SSO accounts). Registration is Customer-first now —
 * the only offered role is Customer; business roles are added later via the add-role flow.
 */
export const NewUserRoleSelection = () => {
  const [agreesWithTermsAndConditions, setAgreesWithTermsAndConditions] =
    useState(false);
  const dispatch = useDispatch();
  const { mutate: updateUserRole } = usePutAuthRoleMutation({
    onSuccess: () => {
      dispatch(getUserInfoAsync.request(undefined));
    },
  });
  const { t } = useResource();

  return (
    <Stack justifyContent="space-between" height="100%">
      <Stack>
        <Typography variant="h6">
          {t(Resources.Auth.SSO.CompleteSSORegistration.Welcome)}
        </Typography>
        <Typography variant="body1">
          {t(Resources.Auth.SSO.CompleteSSORegistration.Description)}
        </Typography>
        <Stack gap={4} my={8}>
          <RoleSelectionCard
            value={AccessRoleCodes.Customer}
            label={t(
              Resources.Auth.SSO.CompleteSSORegistration.RoleLabel.Customer,
            )}
            description={t(
              Resources.Auth.SSO.CompleteSSORegistration.RoleDescription
                .Customer,
            )}
            selected
            onChange={() => undefined}
          />
        </Stack>
      </Stack>
      <Stack gap={2}>
        <CheckboxInput
          name="agreeWithTermsAndConditions"
          label={<MooneLiteEULACheckboxLabel />}
          checked={agreesWithTermsAndConditions}
          onChange={() => setAgreesWithTermsAndConditions((prev) => !prev)}
        />
        <PrimaryButton
          variant="contained"
          color="primary"
          onClick={() =>
            updateUserRole({ accessRoleCode: AccessRoleCodes.Customer })
          }
          endIcon={<ExitToAppIcon />}
          disabled={!agreesWithTermsAndConditions}
        >
          {`${t(Resources.Auth.SSO.CompleteSSORegistration.SignUpAs)} ${t(
            Resources.Auth.SSO.CompleteSSORegistration.RoleLabel.Customer,
          )}`}
        </PrimaryButton>
      </Stack>
    </Stack>
  );
};
